import React, { useState, useEffect } from "react";
import "../../../css/MonthWeekSubsc.css";
import { useDispatch, useSelector } from "react-redux";
import { SubscMonthWeek, fetchAsyncSubscMonthWeek } from "../SubscriberSlice";
import {
  ComposedChart,
  Tooltip,
  XAxis,
  CartesianGrid,
  Legend,
  YAxis,
  Bar,
  ResponsiveContainer,
} from "recharts";

const MonthWeekSubsc = () => {
  const dispatch = useDispatch();
  const SubscMonthWeekData = useSelector(SubscMonthWeek);

  const [page, setPage] = useState(1);
  const handlePage = (item: number) => {
    setPage(page + item);
  };


  useEffect(() => {
    // 初回描画時に実行する処理
    dispatch(fetchAsyncSubscMonthWeek(page));

    // 定期実行を設定
    const interval = setInterval(() => {
      dispatch(fetchAsyncSubscMonthWeek(page));
    }, 60000); // 60秒ごとに実行

    // コンポーネントのクリーンアップ時にインターバルをクリア
    return () => clearInterval(interval);
  }, [dispatch, page]); // 依存配列にdispatchを含める

  return (
    <div className="week_month_container">
      <div className="week_month_title_container">
        <div className="back" onClick={() => handlePage(1)}>
          ←
        </div>
        {SubscMonthWeekData && SubscMonthWeekData.length > 0 && (
          <h2 className="week_month_title">
            曜日別登録者数/{SubscMonthWeekData[0]["month"]}
          </h2>
        )}
            {SubscMonthWeekData && SubscMonthWeekData.length < 1 && (
          <h2 className="week_month_title">
            曜日別登録者数/
          </h2>
        )}
        <div
          className="next"
          onClick={() => {
            handlePage(-1);
          }}>
          →
        </div>
      </div>
      <ResponsiveContainer height="70%" width="90%">
        <ComposedChart
          height={300}
          data={SubscMonthWeekData!}
          className="bar_chart">
          <XAxis dataKey="week" />
          <YAxis dataKey="count" />
          <Tooltip />
          <Legend />
          <CartesianGrid stroke="#f5f5f5" />
          <Bar
            dataKey="count"
            barSize={20}
            stroke="rgba(34, 80, 162, 0.2)"
            fillOpacity={1}
            fill="#4cceac"
            name="登録者数"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MonthWeekSubsc;
